import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import callApi from '@returnmates/client-core/src/graphql/callApi'
import useSubscription from '@returnmates/client-core/src/utils/useSubscription'
import { memo } from 'react'

import { ConsolidationType } from '../Main/types'
import ConsolidationsSection from './components/ConsolidationsSection'
import ContainersSection from './components/ContainersSection'
import useStyles from './styles'

interface ConsolidationsProps {
  type: ConsolidationType
}

function Consolidations({ type }: ConsolidationsProps) {
  const classes = useStyles()
  useSubscription(callApi.onPackageUpdate, actions.onPackageUpdate, 'onPackageUpdate')

  return (
    <div className={classes.pickups}>
      <div className={classes.pickupsGroup}>
        {type === ConsolidationType.Inbound ? <ConsolidationsSection /> : <ContainersSection />}
      </div>
    </div>
  )
}

export default memo(Consolidations)
